import { render, staticRenderFns } from "./ArchivePage.vue?vue&type=template&id=7bb09fc4&scoped=true"
import script from "./ArchivePage.vue?vue&type=script&lang=js"
export * from "./ArchivePage.vue?vue&type=script&lang=js"
import style0 from "./ArchivePage.vue?vue&type=style&index=0&id=7bb09fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb09fc4",
  null
  
)

export default component.exports